import Lang from '/@/modules/core/app/services/Lang';
import Enum from '/@/modules/core/app/helpers/Enum';

export class FuneralPreArrangementServiceType extends Enum {
  static FUNERAL_SERVICE = {
    key: 'funeral_service',
    get value() {
      return Lang.t('asset.funeral-service');
    },
    get description() {
      return Lang.t('asset.service-or-casket');
    }
  };

  static MEMORIAL_SERVICE = {
    key: 'memorial_service',
    get value() {
      return Lang.t('asset.memorial-service');
    },
    get description() {
      return Lang.t('asset.service-portrait-an');
    }
  };

  static GRAVE_SIDE_SERVICE = {
    key: 'grave_side_service',
    get value() {
      return Lang.t('asset.grave-side-service');
    },
    get description() {
      return Lang.t('asset.service-the-cemetery');
    }
  };

  static NO_SERVICE = {
    key: 'no_service',
    get value() {
      return Lang.t('asset.no-service');
    }
  };
}
